// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;


//cambio
const serverImg = 'https://bipa.nbg1.your-objectstorage.com/public';
const server = "https://apibipa.mansolutions.app";
const port = 443;
const domain = "bipa.mansolutions.app";
export { server, port, domain, serverImg };
